import { NavLink } from 'react-router-dom';
import promotionConfig from '../../../promotionConfig';

const SecondaryNav = () => {
    const footerSecondaryNavLinks = promotionConfig?.footerSecondaryNavLinks ?? [];

    return (
        <nav>
            <ul className='nav-list'>
                {footerSecondaryNavLinks.map((link, key) => (
                    <li className={`menu--${key}`} key={`main-menu--${key}`}>
                        <NavLink to={link.uri} activeClassName='active'>
                            {link.title}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default SecondaryNav;
